<syslink-modal
  #modal
  [title]="title"
  (onValidate)="onValidateButtonClicked(modal.data)"
  width="350"
>
  <p
    *ngIf="content"
    class="text-center m-0"
    [innerHTML]="content | translate"
  ></p>

  <syslink-select
    #select
    label="Invoice"
    [filter]="selectFilters"
    [store]="saleInvoicesService.store"
    [(model)]="modal.data.Invoice"
    displayKey="NameFormatted"
    [expand]="expand"
  ></syslink-select>
</syslink-modal>